import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import NavbarSection from "../components/NavbarSection";
import FooterSection from "../components/FooterSection";

const DeleteAccount = () => {
  return (
    <>
      {/* Navbar without vector background */}
      <div style={{ 
        backgroundColor: "#f0f0f0",
        paddingBottom: "20px" 
      }}>
        <NavbarSection />
      </div>

      {/* Delete Account Section */}
      <div style={{ 
        backgroundColor: "#f0f0f0", 
        minHeight: "100vh",
        padding: "80px 0"
      }}>
        <Container>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <Row className="justify-content-center">
              <Col lg={10}>
                {/* Main Heading */}
                <h1 style={{ 
                  fontSize: "3.5rem", 
                  fontWeight: "700",
                  color: "#1a1a2e",
                  marginBottom: "2rem",
                  lineHeight: "1.2"
                }}>
                  Delete Your WriteOffGenie Account
                </h1>
                
                <p style={{ 
                  fontSize: "1.05rem", 
                  color: "#4a4a4a",
                  lineHeight: "1.7",
                  marginBottom: "2rem"
                }}>
                  You can permanently delete your WriteOffGenie account directly in the app:
                </p>

                {/* Steps */}
                <ol style={{ 
                  fontSize: "1.05rem", 
                  color: "#4a4a4a",
                  lineHeight: "1.9",
                  marginBottom: "3rem",
                  paddingLeft: "1.5rem"
                }}>
                  <li className="mb-2">
                    Open the <strong>WriteOffGenie app</strong>.
                  </li>
                  <li className="mb-2">
                    Go to the <strong>Profile</strong> tab.
                  </li>
                  <li className="mb-2">
                    Select <strong>Delete Account</strong>.
                  </li>
                  <li>
                    Confirm your choice.
                  </li>
                </ol>

                {/* What happens section */}
                <h2 style={{ 
                  fontSize: "2rem", 
                  fontWeight: "700",
                  color: "#1a1a2e",
                  marginBottom: "1.5rem",
                  marginTop: "3rem"
                }}>
                  What happens when you delete your account:
                </h2>

                <ul style={{ 
                  fontSize: "1.05rem", 
                  color: "#4a4a4a",
                  lineHeight: "1.9",
                  marginBottom: "3rem",
                  paddingLeft: "1.5rem",
                  listStyleType: "disc"
                }}>
                  <li className="mb-2">
                    Your account information (name, email, phone, and business profile) is permanently removed from our systems.
                  </li>
                  <li className="mb-2">
                    Linked bank and card connections are disconnected.
                  </li>
                  <li className="mb-2">
                    All receipts, transaction records, and deduction PDFs stored in our secure Firebase servers are permanently deleted.
                  </li>
                  <li>
                    Once deleted, this data cannot be recovered.
                  </li>
                </ul>

                {/* Important Notes */}
                <h2 style={{ 
                  fontSize: "2rem", 
                  fontWeight: "700",
                  color: "#1a1a2e",
                  marginBottom: "1.5rem",
                  marginTop: "3rem"
                }}>
                  Important Notes:
                </h2>

                <ul style={{ 
                  fontSize: "1.05rem", 
                  color: "#4a4a4a",
                  lineHeight: "1.9",
                  marginBottom: "2rem",
                  paddingLeft: "1.5rem",
                  listStyleType: "disc"
                }}>
                  <li className="mb-2">
                    Deletion is permanent and cannot be undone.
                  </li>
                  <li className="mb-2">
                    If you have an active paid subscription, please cancel it first in the app store (Google Play / Apple App Store).
                  </li>
                  <li>
                    If you need assistance, contact us at{" "}
                    <a 
                      href="mailto:support@writeoffgenie.ai" 
                      style={{ 
                        color: "#08a040ff",
                        textDecoration: "none",
                        fontWeight: "400"
                      }}
                    >
                      support@writeoffgenie.ai
                    </a>
                  </li>
                </ul>

              </Col>
            </Row>
          </motion.div>
        </Container>
      </div>

      <FooterSection />
    </>
  );
};

export default DeleteAccount;